import React from 'react';
import { RelayEnvironmentProvider } from 'react-relay';
import { mapEventMetadata, NovaEventingProvider, NovaGraphQLProvider } from '@nova/react';
import { getEnvironment } from 'owa-relay';
import { novaGraphQL } from './NovaGraphQL';
import { novaEventing } from './NovaEventing';

interface NovaProviderProps {
    children: React.ReactNode;
}

export const NovaContextProvider: React.FunctionComponent<NovaProviderProps> = props => {
    const { children } = props;
    return (
        <RelayEnvironmentProvider environment={getEnvironment()}>
            <NovaGraphQLProvider graphql={novaGraphQL}>
                <NovaEventingProvider eventing={novaEventing} reactEventMapper={mapEventMetadata}>
                    {children}
                </NovaEventingProvider>
            </NovaGraphQLProvider>
        </RelayEnvironmentProvider>
    );
};

NovaContextProvider.displayName = 'NovaContextProvider';
